// extracted by mini-css-extract-plugin
export default {"page_not_found":"PageNotFoundPage_page_not_found__UQZxY"};